<template>
	<el-menu router :default-active="$route.path">
		<!-- 班级管理（小组管理）-->
		<el-submenu index="team">
			<template slot="title">
				<i class="el-icon-s-custom"></i>
				<span>班级管理</span>
			</template>
			<el-menu-item index="/teacher/teamManagement">小组管理</el-menu-item>
		</el-submenu>

		<!-- 课堂管理 -->
		<el-submenu index="course">
			<template slot="title">
				<i class="el-icon-s-order"></i>
				<span>课堂管理</span>
			</template>
			<el-menu-item index="/teacher/dashboard">课程列表</el-menu-item>
			<el-menu-item index="/teacher/class-history">历史课堂记录</el-menu-item>
		</el-submenu>
		<el-menu-item index="/teacher/AgentSchoolManagement" v-if="MenuList.includes('AgentSchoolManagement')">
			<i class="el-icon-s-data"></i>
			<span>智能体统计</span>
		</el-menu-item>
		<el-menu-item index="/teacher/schoolModelManagement" v-if="MenuList.includes('schoolModelManagement')">
			<i class="el-icon-s-opportunity"></i>
			<span>模型管理</span>
		</el-menu-item>
		<!-- 学校管理（超管/管理员可见） -->
		<el-menu-item index="/teacher/school" v-if="isAdmin||MenuList.includes('schoolManagement')">
			<i class="el-icon-school"></i>
			<span>学校管理</span>
		</el-menu-item>
		
		
	</el-menu>
</template>

<script>
	export default {
		name: 'TeacherMenu',
		data() {
			return {
				userInfo: null,
				isAdmin: false,
				schoolAdmin:false,
				MenuList:'',
			}
		},
		created() {
			// 从缓存读取用户信息
			if (localStorage.getItem('userType') == 2 && localStorage.getItem('roleType') == 1) {
				this.isAdmin = true
			} else {
				this.isAdmin = false
			}
			const MenuList=localStorage.getItem('MenuList')
			if (MenuList) {
				this.MenuList=MenuList
			}
		}
	}
</script>